import store from "../store"
import { socialConnect } from "../actions/misc"
import { openSnackBar } from "../actions/snack-bar"

export const handleConnect = (network, id, data) => {
  switch (network) {
    case "twitter":
      store
        .dispatch(socialConnect(id, data))
        .then(res => {
          store.dispatch(openSnackBar({ message: "Twitter Added" }))
        })
        .catch(error =>
          store.dispatch(openSnackBar({ message: "Failed to add network." }))
        )
      break
    // the commented code will be used in the future development
    // case "Facebook":
    //   store.dispatch(toggleFacebookConnected())
    //   store
    //     .dispatch(connectFacebook())
    //     .then(res => {
    //       console.log(res)
    //     })
    //     .catch(error => {
    //       console.log(error)
    //     })
    //   break
    // case "LinkedIn":
    //   store
    //     .dispatch(getLinkedInAuthCode())
    //     .then(res => {
    //       console.log(res)
    //     })
    //     .catch(error => {
    //       store.dispatch(openSnackBar({ message: "Failed to add network." }))
    //     })

    //   break
    // case "Hootsuite":
    //   store
    //     .dispatch(getHootsuiteAuthCode())
    //     .then(res => {
    //       console.log(res)
    //     })
    //     .catch(error => {
    //       console.log(error)
    //     })
    //   break
    // case "Youtube":
    // case "YouTube":
    //   store
    //     .dispatch(getYoutubeAuthCode())
    //     .then(res => {
    //       console.log(res)
    //     })
    //     .catch(error => {
    //       console.log(error)
    //     })
    //   break
    default:
      return
  }
  //   store.dispatch(getCurrentOrg())
}
